import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as kioskAPI from '../../lib/api/kiosk';

const INITIALIZE = 'kiosk/INITIALIZE';
const INIT_RES = 'kiosk/INIT_RES';

const [
  LOAD_KIOSK_INFO,
  LOAD_KIOSK_INFO_SUCCESS,
  LOAD_KIOSK_INFO_FAILURE,
] = createRequestActionTypes('kiosk/LOAD_KIOSK_INFO');

const [
  MODIFY_KIOSK_INFO,
  MODIFY_KIOSK_INFO_SUCCESS,
  MODIFY_KIOSK_INFO_FAILURE,
] = createRequestActionTypes('kiosk/MODIFY_KIOSK_INFO');

export const initialize = createAction(INITIALIZE);
export const initRes = createAction(INIT_RES);

export const loadKioskInfo = createAction(
  LOAD_KIOSK_INFO,
  ({ clubID }) => ({ clubID }),
);

export const modifyKioskInfo = createAction(
  MODIFY_KIOSK_INFO,
  ({ clubID, title, titleSize, memo, memoSize, imageURL, phone, password }) => ({
    clubID,
    title,
    titleSize,
    memo,
    memoSize,
    imageURL,
    phone,
    password,
  }),
);

const loadKioskInfoSaga = createRequestSaga(LOAD_KIOSK_INFO, kioskAPI.loadKioskInfo);
const modifyKioskInfoSaga = createRequestSaga(MODIFY_KIOSK_INFO, kioskAPI.modifyKioskInfo);

export function* kioskSaga() {
  yield takeLatest(LOAD_KIOSK_INFO, loadKioskInfoSaga);
  yield takeLatest(MODIFY_KIOSK_INFO, modifyKioskInfoSaga);
}

const initialState = {
  kioskInfo: null,
  modifyRes: null,
  error: null,
};

const kiosk = handleActions(
  {
    [INITIALIZE]: () => initialState,
    [INIT_RES]: (state) => ({
      ...state,
      modifyRes: null,
      error: null,
    }),
    [LOAD_KIOSK_INFO_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      kioskInfo: res.info,
    }),
    [LOAD_KIOSK_INFO_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [MODIFY_KIOSK_INFO_SUCCESS]: (state, { payload: res }) => ({
      ...state,
      modifyRes: res.result,
    }),
    [MODIFY_KIOSK_INFO_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
  },
  initialState,
);

export default kiosk;

